import { post, get } from '../axios'

export function filterPage(params) {
  return post(`${process.env.VUE_APP_ADMIN}/collect/filter/page`, params)
}

export function filterDetail(params) {
  return post(`${process.env.VUE_APP_ADMIN}/collect/filter/detail`, params)
}

export function filterModify(params) {
  return post(`${process.env.VUE_APP_ADMIN}/collect/filter/modify`, params)
}

export function getUiniqId(params) {
  return get(`${process.env.VUE_APP_LANG}/mdm/site/v2/list`, params)
}

export function filterDel(params) {
  return post(`${process.env.VUE_APP_ADMIN}/collect/filter/delete`, params)
}

export function filterAttr(params) {
  return post(`${process.env.VUE_APP_ADMIN}/collect/filter/listCmcAttr`, params)
}

export function getQuickFilterDetail(params) {
  return get(
    `${process.env.VUE_APP_ADMIN}/collect/filter/getQuickFilterDetail`,
    params
  )
}

export function listSearchAttr(params) {
  return post(
    `${process.env.VUE_APP_ADMIN}/collect/filter/listSearchAttr`,
    params
  )
}

export function queryColBannerFilter(params) {
  return post(
    `${process.env.VUE_APP_ADMIN}/col/ad/queryColBannerFilter`,
    params
  )
}

export function user_list(params) {
  return get(`${process.env.VUE_APP_PUBLIC}/user/list`, params)
}
